/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

//TODO:
require('./src/styles/global.scss');
const React = require('react');
const fsSnippet = require('./src/gatsby/fsSnippet').default;
// You can delete this file if you're not using it
let runInIframe = false;

exports.wrapRootElement = ({ element }) => <React.StrictMode>{element}</React.StrictMode>;

exports.onRenderBody = ({ setHeadComponents }) => {
  setHeadComponents(
    <script
      dangerouslySetInnerHTML={{
        __html: `
            window['_fs_debug'] = false;
            window['_fs_run_in_iframe'] = ${runInIframe};
            window['_fs_host'] = 'staging.fullstory.com';
            window['_fs_script'] = 'edge.staging.fullstory.com/s/fs.js';
            window['_fs_org'] = 'thefullstory.com';
            window['_fs_namespace'] = 'FS';
            ${fsSnippet}
        `,
      }}
    />
  );
};

exports.onInitialClientRender = () => {
  if (process.env.GATSBY_ENABLE_NOBLE === 'true') {
    const iframe = document.createElement('iframe');
    iframe.src =
      'https://buyers.thatsnoble.com/conversion?tenant-id=7880526e-3d0a-4dcd-a795-a5aacc49f92f&conversion-type-id=cc4ac086-94d3-422d-b43f-4adbcb741cdf';
    iframe.id = 'noble-conversion-tag';
    iframe.style.display = 'none';
    iframe.width = '0';
    iframe.height = '0';
    iframe.setAttribute('title', 'Noble Conversion');
    iframe.setAttribute('aria-hidden', 'true');
    document.body.appendChild(iframe);
  }
  if (typeof window !== 'undefined') {
    window['_fs_run_in_iframe'] = runInIframe;
  }
};

exports.shouldUpdateScroll = () => {
  if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
    return false;
  }
  window.scrollTo(0, 0);

  return false;
};
